import { Navigate } from 'react-router-dom'
import { useUsuario } from '../../contexts/UsuarioContext'

interface AdminRouteProps {
  children: React.ReactNode
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { usuario, loading } = useUsuario()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Carregando...</p>
        </div>
      </div>
    )
  }

  const isAdministrador = usuario?.papeis?.includes('1') ?? false

  if (!isAdministrador) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
